import type { ComponentImport } from "../../shared/types";
import type { SearchRequestFacetFilterModel } from "../../shared/apiClient/data-contracts";
// Statically imported: this module is already in the entry chunk via
// site/features/search/search.ts, so a dynamic import cannot split it out.
import { consumeHeaderSearchLogMarker } from "../../shared/searchActivityStorage";

// eslint-disable-next-line @typescript-eslint/no-misused-promises
document.addEventListener("DOMContentLoaded", initSearch);

async function initSearch() {
    const element = document.getElementById("search-app");
    if (!element) return;

    const { createApp } = await import("vue");
    // @ts-ignore
    const { default: App } = (await import("./features/searchPage/SearchPage.vue")) as ComponentImport;
    const { default: i18n } = await import("./plugins/i18n");
    const { createPinia } = await import("pinia");
    const { useSearchStore } = await import("./stores/search");
    const { getQueryParam } = await import("./../../shared/urlPropUtilities");
    await import("../../shared/theming.css");

    // Import Filters
    const searchLanguage = element.getAttribute("data-search-language") ?? "";
    const searchType = Number(element.getAttribute("data-search-type") ?? "1");
    const app = createApp(App);

    // Global Usings
    app.use(i18n, window.i18n).use(createPinia());

    const searchStore = useSearchStore();

    const filters = getQueryParam(window.location.search, "filters");
    const searchTerm = getQueryParam(window.location.search, "q") ?? "";
    const per = Number(getQueryParam(window.location.search, "per") ?? "10");
    const page = Number(getQueryParam(window.location.search, "page") ?? "1");

    searchStore.searchRequest.searchType = searchType;
    searchStore.searchRequest.searchLanguage = searchLanguage;
    searchStore.searchRequest.searchTerm = searchTerm;
    searchStore.searchRequest.facetFilters = filters ? (JSON.parse(filters) as SearchRequestFacetFilterModel[]) : [];
    searchStore.searchRequest.resultsPerPage = per;
    searchStore.searchRequest.page = page;
    searchStore.ndaUrl = document.documentElement.getAttribute("data-nda-url") ?? "";

    const logActivity = consumeHeaderSearchLogMarker();

    app.mount(element);
    await searchStore.search(true, logActivity);

    // if the parent container id equals the hash, scroll the parent container into view
    if (element.parentElement?.id === globalThis.location.hash.replace("#", "")) {
        setTimeout(() => {
            element.parentElement?.scrollIntoView({ behavior: "smooth" });
        }, 200);
    }
}
